import * as saux from '@saux/design-tokens/index';
export var SAUX360Theme = {
    metadata: {
        name: 'SAUX360Theme',
        version: '1.0.0',
    },
    color: {
        accent: {
            background: 'hsl(195, 79%, 45%)',
            foreground: 'hsl(195, 0%, 100%)',
        },
        active: {
            background: saux.ColorFillAlert,
            foreground: 'white',
        },
        alert: {
            background: saux.ColorFillAlert,
            foreground: saux.ColorFontAlert,
        },
        background: {
            background: saux.ColorFillScreenBackground,
            foreground: saux.ColorFontContainer,
        },
        container: {
            background: saux.ColorFillContainer,
            foreground: saux.ColorFontContainer,
        },
        dark: {
            background: 'hsl(0, 0%, 23%)',
            foreground: 'hsl(0, 0%, 100%)',
        },
        highlight: {
            background: 'hsl(287, 66%, 42%)',
            foreground: 'white',
        },
        info: {
            background: 'lightblue',
            foreground: saux.ColorFontContainer,
        },
        light: {
            background: 'hsl(0, 0%, 100%)',
            foreground: 'hsl(0, 0%, 23%)',
        },
        link: {
            background: 'transparent',
            foreground: saux.ColorFillPrimary,
        },
        modal: {
            background: saux.ColorFillModalScreenBackground,
            foreground: saux.ColorFillModalScreenBackground,
        },
        outline: {
            background: saux.ColorFontContainer,
            foreground: saux.ColorFontContainer,
        },
        primary: {
            background: saux.ColorFillPrimary,
            foreground: saux.ColorFontPrimary,
        },
        secondary: {
            background: 'hsl(87, 85%, 28%)',
            foreground: saux.ColorFontSecondary,
        },
        section: {
            background: saux.ColorFillContainerSection,
            foreground: saux.ColorFontContainerSection,
        },
        tertiary: {
            background: saux.ColorFillTertiary,
            foreground: saux.ColorFontTertiary,
        },
        warning: {
            background: 'red',
            foreground: 'white',
        },
        disabled: {
            background: 'hsl(0, 0%, 88%)',
            foreground: 'hsl(0, 0%, 59%)',
        },
    },
    colors: {
        text: 'hsl(0, 0%, 23%)',
        primary: saux.ColorFillPrimary,
        secondary: 'hsl(87, 85%, 28%)',
        success: 'hsl(87, 85%, 28%)',
        error: 'hsl(349, 100%, 35%)',
        warning: 'hsl(37, 91%, 55%)',
        info: 'hsl(195, 79%, 45%)',
        black: 'hsl(0, 0%, 0%)',
        disabledLight: 'hsl(0, 0%, 88%)',
        disabledDark: 'hsl(0, 0%, 59%)',
        disabledGrey: 'hsla(0, 0%, 88%)',
        white: 'hsl(0, 0%, 100%)',
        accentBlue: 'hsl(195, 79%, 45%)',
        accentBlue50: 'hsl(190, 66%, 93%)',
        accentBlue100: 'hsl(190, 66%, 83%)',
        accentBlue200: 'hsl(191, 68%, 72%)',
        accentBlue300: 'hsl(192, 68%, 62%)',
        accentBlue400: 'hsl(194, 70%, 55%)',
        accentBlue500: 'hsl(194, 73%, 49%)',
        accentBlue600: 'hsl(195, 79%, 45%)',
        accentBlue700: 'hsl(195, 93%, 38%)',
        accentBlue800: 'hsl(197, 92%, 34%)',
        accentBlue900: 'hsl(199, 100%, 26%)',
        gray: 'hsl(0, 0%, 34%)',
        gray50: 'hsl(0, 0%, 93%)',
        gray100: 'hsl(0, 0%, 88%)',
        gray200: 'hsl(0, 0%, 80%)',
        gray300: 'hsl(0, 0%, 70%)',
        gray400: 'hsl(0, 0%, 59%)',
        gray500: 'hsl(0, 0%, 50%)',
        gray600: 'hsl(0, 0%, 42%)',
        gray700: 'hsl(0, 0%, 34%)',
        gray800: 'hsl(0, 0%, 29%)',
        gray900: 'hsl(0, 0%, 23%)',
        green: 'hsl(87, 85%, 28%)',
        green50: 'hsl(116, 39%, 93%)',
        green100: 'hsl(111, 40%, 84%)',
        green200: 'hsl(106, 39%, 74%)',
        green300: 'hsl(100, 39%, 65%)',
        green400: 'hsl(96, 38%, 55%)',
        green500: 'hsl(91, 43%, 46%)',
        green600: 'hsl(87, 61%, 36%)',
        green700: 'hsl(87, 85%, 28%)',
        green800: 'hsl(83, 69%, 25%)',
        green900: 'hsl(83, 45%, 23%)',
        blue: 'hsl(205, 99%, 39%)',
        blue50: 'hsl(200, 100%, 94%)',
        blue100: 'hsl(201, 100%, 85%)',
        blue200: 'hsl(201, 100%, 75%)',
        blue300: 'hsl(200, 100%, 64%)',
        blue400: 'hsl(200, 100%, 55%)',
        blue500: 'hsl(201, 100%, 50%)',
        blue600: 'hsl(202, 100%, 47%)',
        blue700: 'hsl(203, 100%, 43%)',
        blue800: 'hsl(205, 99%, 39%)',
        blue900: 'hsl(210, 91%, 34%)',
        blueGray: 'hsl(220, 38%, 97%)',
        blueGray50: 'hsl(220, 38%, 97%)',
        blueGray100: 'hsl(214, 33%, 92%)',
        blueGray200: 'hsl(214, 30%, 86%)',
        blueGray300: 'hsl(215, 29%, 81%)',
        blueGray400: 'hsl(215, 27%, 75%)',
        blueGray500: 'hsl(215, 26%, 69%)',
        blueGray600: 'hsl(213, 19%, 62%)',
        blueGray700: 'hsl(214, 13%, 54%)',
        blueGray800: 'hsl(215, 10%, 46%)',
        blueGray900: 'hsl(217, 10%, 37%)',
        red: 'hsl(349, 100%, 35%)',
        red50: 'hsl(347, 83%, 95%)',
        red100: 'hsl(350, 86%, 89%)',
        red200: 'hsl(356, 67%, 75%)',
        red300: 'hsl(356, 63%, 65%)',
        red400: 'hsl(356, 78%, 60%)',
        red500: 'hsl(357, 84%, 56%)',
        red600: 'hsl(354, 73%, 51%)',
        red700: 'hsl(352, 75%, 46%)',
        red800: 'hsl(352, 80%, 42%)',
        red900: 'hsl(349, 100%, 35%)',
        slate50: 'hsl(213, 61%, 95%)',
        slate100: 'hsl(213, 54%, 90%)',
        slate200: 'hsl(214, 41%, 79%)',
        slate300: 'hsl(214, 40%, 71%)',
        slate400: 'hsl(213, 33%, 56%)',
        slate500: 'hsl(214, 29%, 51%)',
        slate600: 'hsl(213, 28%, 44%)',
        slate700: 'hsl(213, 30%, 35%)',
        slate800: 'hsl(215, 48%, 22%)',
        slate900: 'hsl(215, 89%, 14%)',
    },
    font: {
        primary: {
            family: saux.AssetFontFamily,
            size: {
                small: '12px',
                smallTEMP: '14px',
                medium: '16px',
                mediumTEMP: '18px',
                large: '20px',
                xl: '25px',
                xxl: '31px',
            },
            url: saux.AssetFontImportUrl,
            weight: {
                bold: '700',
                normal: '400',
            },
        },
        sizes: {
            '50': '0.579rem',
            '100': '0.694rem',
            '200': '0.833rem',
            '300': '1rem',
            '400': '1.2rem',
            '500': '1.44rem',
            '600': '1.728rem',
            '700': '2.074rem',
            '800': '2.488rem',
            '900': '2.986rem',
        },
    },
    separator: {
        accent: {
            color: 'hsl(287, 66%, 42%)',
            radius: '4px',
            thickness: '4px',
        },
        line: {
            color: 'rgb(217, 223, 235)',
            radius: '1px',
            thickness: '1px',
        },
    },
    shadow: {
        elevation: {
            level1: saux.ShadowCardX + " " + saux.ShadowCardY + " " + saux.ShadowCardBlur + " " + saux.ShadowCardSpread + " " + saux.ShadowCardColor,
            level2: saux.ShadowHeaderX + " " + saux.ShadowHeaderY + " " + saux.ShadowHeaderBlur + " " + saux.ShadowHeaderSpread + " " + saux.ShadowCardColor,
            level3: "",
            level4: "",
            level5: "",
        },
    },
    size: {
        icon: {
            small: saux.SizeIconSmall,
            medium: saux.SizeIconMedium,
            large: saux.SizeIconLarge,
            xl: saux.SizeIconXl,
            xxl: saux.SizeIconXxl,
        },
        radius: {
            /** 4px */
            small: '4px',
            medium: '8px',
            large: '12px',
            round: '50%',
        },
        spacer: {
            xxs: saux.SizeSpacerXxs,
            xs: saux.SizeSpacerXs,
            small: saux.SizeSpacerS,
            medium: saux.SizeSpacerM,
            large: saux.SizeSpacerL,
            xl: saux.SizeSpacerXl,
            xxl: saux.SizeSpacerXxl,
        },
    },
};
//# sourceMappingURL=saux-360.theme.js.map